import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import g from "./iconfont.es5471.js";
const d = {
  display: "block"
}, v = ({ size: e = 16, useVw: t, useRem: o, color: l, withColor: c, removeClassName: n, disableSSR: h, style: i, ...m }) => {
  const p = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(g, { disableSSR: h }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-lianshangchongzhi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), height: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: p, fill: "none", ...m }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: n ? "" : "24px-é¾ä¸åå¼"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: n ? "" : "normal",
        fill: c ? r(l, 0, "#262933") : "#262933",
        datafollowfill: c ? r(l, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M6.574 2.45a4.081 4.081 0 0 0-4.082 4.081v1.094a.8.8 0 1 0 1.6 0V6.531A2.481 2.481 0 0 1 6.574 4.05H17.51c.767 0 1.388.621 1.388 1.388v3.828h-1.935a2.734 2.734 0 0 0 0 5.468H18.9v3.829c0 .766-.622 1.387-1.388 1.387H6.574a2.481 2.481 0 0 1-2.482-2.481v-1.094a.8.8 0 0 0-1.6 0v1.094a4.081 4.081 0 0 0 4.082 4.081H17.51a2.988 2.988 0 0 0 2.988-2.987v-3.84a2.735 2.735 0 0 0 0-5.446V5.438A2.988 2.988 0 0 0 17.51 2.45H6.574Zm10.39 8.416h3.282a1.134 1.134 0 0 1 0 2.268h-3.282a1.134 1.134 0 1 1 0-2.268Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M1.18 11.992a.8.8 0 0 1 .8-.8h5.83L6.533 9.808a.8.8 0 0 1 1.175-1.085l2.516 2.726a.8.8 0 0 1 .002 1.083L7.71 15.275a.8.8 0 0 1-1.18-1.081l1.286-1.402H1.98a.8.8 0 0 1-.8-.8Z"
        }
      )
    )
  )));
}, E = v;
export {
  E as default
};
